'use client';
import { useState } from 'react';

var useUncontrolled = function(param) {
    var value = param.value, defaultValue = param.defaultValue, finalValue = param.finalValue, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {
        return Function;
    } : _param_onChange;
    var _useState = useState(defaultValue !== undefined ? defaultValue : finalValue), uncontrolledValue = _useState[0], setUncontrolledValue = _useState[1];
    var handleUncontrolledChange = function(value) {
        setUncontrolledValue(value);
        onChange == null ? void 0 : onChange(value);
    };
    if (value !== undefined) {
        return [
            value,
            onChange,
            true
        ];
    }
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
};

export { useUncontrolled };
